<template>
	<div class='result-table-2'>
		<table class='table-common'>
			<thead>
				<tr>
					<th>Источник данных</th>
					<th>Состав</th>
					<th>Порода</th>
					<th>Возраст, лет</th>
					<th>Средняя высота, м</th>
					<th>Средний диаметр, см</th>
					<th>Тип леса</th>
					<!--<th>ТУМ</th>-->
					<th>Полнота</th>
					<th>Бонитет</th>
					<th>Запас, куб.м/га</th>
				</tr>
			</thead>
			<tbody>
				<template v-if='dataIsLoading'>
					<div class='table-common__loading-container'>
						<div>
							<p-spinner class='table-common__loading-spinner'/>
						</div>
						<div class='table-common__loading-text'>Загрузка данных...</div>
					</div>
				</template>

				<template v-if='dataIsLoading && !tableData.length'>
					<tr>
						<td colspan='20' class='table-common__loading-empty-row'></td>
					</tr>
				</template>

				<template v-else>
					<tr v-for='row in tableData'>
						<td v-if='isStartSource(row)' :rowspan='getSourceCount(row)'>{{ row.data_source }}</td>
						<td>{{ row.composition }}</td>
						<td>{{ row.species }}</td>
						<td>{{ row.age }}</td>
						<td>{{ row.h }}</td>
						<td>{{ row.d }}</td>
						<td>{{ row.forest_type }}</td>
						<!--<td>{{ row.tum }}</td>-->
						<td>{{ row.fullness }}</td>
						<td>{{ row.bonitet }}</td>
						<td>{{ row.stock }}</td>
					</tr>
				</template>

			</tbody>
		</table>
	</div>
</template>

<script>
	const GET_TABLE_DATA = process.env.VUE_APP_ROOT_API + 'get_site_data/result_tables/table1.php';

	export default {
		name: 'ResultTable2',
		data: () => ({
			tableData: [],
			dataIsLoading: false
		}),
		computed: {
			startSourceList() {
				const result = [];
				for (let item of this.tableData) {
					if (!result.find(row => row.data_source === item.data_source)) {
						result.push(item);
					}
				}
				return result;
			},

			lpo() {
				return this.$store.state.selectedLpo.lpo;
			}
		},

		methods: {
			isStartSource(item) {
				return this.startSourceList.includes(item);
			},

			getSourceCount(item) {
				return this.tableData.filter(row => row.data_source === item.data_source).length;
			},

			getTableData() {
				this.dataIsLoading = true;

				const form = new FormData();
				form.append('lpo_id', this.lpo.lpo_id);

				fetch(GET_TABLE_DATA, {
					credentials: 'include',
					method: 'post',
					body: form
				})
				.then(res => res.json())
				.then(res => {
					this.tableData = res;
				})
				.catch(err => { throw err; })
				.finally(() => { this.dataIsLoading = false; });
			}
		},
		created() {
			this.getTableData();
		}
	};
</script>

<style lang='scss' scoped src='@/style/tables.scss'></style>
